<template>
  <label v-if="label" class="formLabel" :class="{ regist: isRegist }">
    <span class="label">{{ label }}</span>
    <span v-if="isRequired" class="required">※必須</span>
  </label>
</template>

<script>
export default {
  name: 'FormLabel',
  props: {
    label: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      default() {
        return { rules: {} }
      },
    },
    required: Boolean,
    register: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isRegist: false,
    }
  },
  computed: {
    isRequired() {
      return this.validation.required || this.required
    },
  },
  mounted() {
    this.isRegist = this.register
  },
}
</script>

<style scoped lang="scss">
.formLabel {
  font-weight: 600;
  display: flex;
  line-height: 1.1;
  align-items: center;
  margin-bottom: 8px;
  .label {
    color: #4F4F4F;
    font-size: 13px;
  }
  .required {
    font-size: 12px;
    margin-left: 3px;
    color: #FF4438;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/FormLabel.vue